import { isJestOrStorybook } from '@/test-helpers/isJestOrStorybook';
import { removeIndexedDbPromise } from '@/utilities/removeIndexedDbPromise';

import { rxdb15DatabaseName } from './dbInitializer';

const rxdb14DBName = 'borer_rxdb_14';

export const removeRxDB15fromStorage = async () => {
  if (isJestOrStorybook()) return;
  const indexDBsList: IDBDatabaseInfo[] = await window.indexedDB.databases();

  // do we have a rxdb 15 database?
  const rxdb15DBExists = indexDBsList.find(idb => idb.name === rxdb15DatabaseName);
  if (rxdb15DBExists) await removeIndexedDbPromise(rxdb15DatabaseName);
};

export const removeRxDB14fromStorage = async () => {
  if (isJestOrStorybook()) return;
  const indexDBsList: IDBDatabaseInfo[] = await window.indexedDB.databases();

  const rxdb14DBExists = indexDBsList.find(idb => idb.name === rxdb14DBName);
  if (rxdb14DBExists) await removeIndexedDbPromise(rxdb14DBName);
};
